import {
  Stack,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import { productExportWarehouseBusiness } from "api/bussiness/product/product-export-warehouse-bussiness";
import { ProductInventoryPermission } from "commons/enum/permission";
import { dateTimeDisplay } from "commons/ultilities/date/dayjs";
import { cloneDeep } from "lodash";
import { observer } from "mobx-react-lite";
import { IProductGoodsIssueProperties } from "mobx-stores/_models/product-inventory/product-goods-issue/product-goods-issue";
import { useStores } from "mobx-stores/_root-store";
import { useCallback, useEffect } from "react";
import { NumberText } from "share-components/atomics/number-text";
import {
  EditIconButton,
  RemoveIconButton,
} from "share-components/mui-wrap/button/action-button";
import { XTablePagination } from "share-components/mui-wrap/table/x-table-pagination";
export const ProductGoodsIssueTable = observer(() => {
  const {
    deleteConfirmationStore,
    productInventoryManagement: {
      productGoodsIssueStore: {
        productGoodsIssues,
        getProductGoodsIssue,
        pagination,
        setProp,
      },
    },
  } = useStores();

  useEffect(() => {
    getProductGoodsIssue();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onPageChanged = useCallback(
    (_: any, page: number) => {
      pagination.setProp("pageIndex", page - 1);
      getProductGoodsIssue();
    },
    [getProductGoodsIssue, pagination]
  );

  const onEditBtnClickHandler = useCallback(
    (item: IProductGoodsIssueProperties) => {
      setProp("openEdit", true);
      setProp("productGoodsIssueDetail", cloneDeep(item));
    },
    [setProp]
  );

  const onDelete = useCallback(
    async (item: IProductGoodsIssueProperties) => {
      if (item && item.id) {
        await productExportWarehouseBusiness.delete(item?.id);
        getProductGoodsIssue();
      }
    },
    [getProductGoodsIssue]
  );

  const onDeleteBtnClickHandler = useCallback(
    (item: IProductGoodsIssueProperties) => {
      setProp("productGoodsIssueDetail", cloneDeep(item));
      deleteConfirmationStore.setProp("open", true);
      deleteConfirmationStore.setDeletionCallback(() => {
        onDelete(item);
      });
    },
    [deleteConfirmationStore, onDelete, setProp]
  );

  return (
    <XTablePagination
      paginationProps={{
        count: pagination.totalPages,
        page: pagination.pageNumber,
        onChange: onPageChanged,
      }}
    >
      <TableHead>
        <TableRow>
          <TableCell>Mã hàng</TableCell>
          <TableCell>Tên hàng</TableCell>
          <TableCell>Ngày nhập</TableCell>
          <TableCell>Số lượng</TableCell>
          <TableCell>Ghi chú</TableCell>
          <TableCell></TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {productGoodsIssues.map((x, i) => (
          <TableRow data-id={x.id} key={x.id} hover>
            <TableCell>{x.items[0]?.product?.code}</TableCell>
            <TableCell>{x.items[0]?.product?.name}</TableCell>
            <TableCell>{dateTimeDisplay(x.exportDate)}</TableCell>
            <TableCell>
              <NumberText value={x.items[0]?.quantity}></NumberText>
            </TableCell>
            <TableCell>{x.items[0]?.note}</TableCell>
            <TableCell width={"20px"}>
              <Stack direction={"row"} spacing={0.5}>
                <EditIconButton
                  accessPermission={[ProductInventoryPermission.ExportUpdate]}
                  onClick={() => onEditBtnClickHandler(x)}
                ></EditIconButton>

                <RemoveIconButton
                  accessPermission={[ProductInventoryPermission.ExportDelete]}
                  onClick={() => onDeleteBtnClickHandler(x)}
                ></RemoveIconButton>
              </Stack>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </XTablePagination>
  );
});
